module.exports = __webpack_public_path__ + "img/ic_myorders.ce3423b2.svg";